exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-list {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-flow: row wrap;\n  width: 100%; }\n  .card-list .card {\n    margin: 15px; }\n    .card-list .card.card-axis-y {\n      flex: 1 0 calc(33% - 30px); }\n    .card-list .card.card-axis-x {\n      flex: 1 0 calc(50% - 30px); }\n    @media (max-width: 768px) {\n      .card-list .card, .card-list .card.card-axis-x, .card-list .card.card-axis-y {\n        flex-basis: 100%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/ui/card-list/card-list.scss
// module id = 303
// module chunks = 0